import { createFileRoute } from '@tanstack/react-router';
import { JourneysFormsDetailsHandoff } from '@/pages/workspaces/integrations/forms/routing';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/integrations/forms_/$type')({
  component: JourneysFormAliasHandoffRoute,
});

function JourneysFormAliasHandoffRoute() {
  const { workspaceId, type } = Route.useParams();
  return <JourneysFormsDetailsHandoff workspaceId={String(workspaceId)} type={type} />;
}
